import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /ri (bare) redireciona para /ri/investidores — a 2ª aba do nav do mock (Dashboards é a 1ª,
 * ainda não construída nesta fatia). Rota própria (não a lista): quando os Dashboards do RI
 * chegarem, só o `to` aqui muda — /ri não passa a significar "lista de investidores" para sempre
 * (brief §6, F6).
 */
export const Route = createFileRoute('/ri/')({
  beforeLoad: () => {
    throw redirect({ to: '/ri/investidores' });
  },
});
